module.exports = __webpack_public_path__ + "static/img/HA-100100.bcb464f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/HA-100100.png
// module id = gpp8
// module chunks = 4